import script from "./UpdateUserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateUserInfo.vue?vue&type=script&setup=true&lang=js"

import "./UpdateUserInfo.vue?vue&type=style&index=0&id=2717cd8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2717cd8e"]])

export default __exports__